"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormErrorBuilder = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _FormSubmitStatus = require("./FormSubmitStatus");
var _getErrorLocalizationByCode = require("./getErrorLocalizationByCode");
const hasKey = (object, key) => {
  const {
    hasOwnProperty
  } = Object.prototype;
  return object != null && hasOwnProperty.call(object, key);
};
const createValidationMessage = (localization, paramsObject = {}) => {
  const params = paramsObject;
  return {
    localization,
    params
  };
};
class FormErrorBuilder {
  constructor(responses, values) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- needs this types
    (0, _defineProperty2.default)(this, "formFieldErrors", {});
    (0, _defineProperty2.default)(this, "formStatusErrors", new _FormSubmitStatus.FormSubmitStatus(false));
    responses.forEach(response => {
      if (response?.Errors) {
        this.addErrors(response, values);
      }
    });
  }
  addErrors(response, values) {
    response.Errors.forEach(error => {
      const localization = (0, _getErrorLocalizationByCode.getErrorLocalizationByCode)(error.Code);
      const message = createValidationMessage(localization);
      if (error.PropertyName) {
        const propertyName = this.formatPropertyName(error.PropertyName);
        const field = propertyName;
        if (field && values && hasKey(values, field)) {
          this.formFieldErrors[field] = {
            message
          };
        } else {
          this.formStatusErrors.modelErrors.push(message);
        }
      } else {
        this.formStatusErrors.modelErrors.push(message);
      }
    });
  }
  get fieldErrors() {
    return this.formFieldErrors;
  }
  get errorStatus() {
    return this.formStatusErrors;
  }
  formatPropertyName(propertyName) {
    return propertyName.charAt(0).toLowerCase() + propertyName.slice(1);
  }
}
exports.FormErrorBuilder = FormErrorBuilder;
//# sourceMappingURL=FormErrorBuilder.js.map